import { authInstance } from './auth-instance';
import { RoleGroupList } from '@/types';

export const roleGroupList = {
    create: (data: RoleGroupList): Promise<boolean> =>
        authInstance.post<boolean>('RoleGroupList/addRolesInGroup', data).then(x => x.data),
    remove: (data: RoleGroupList): Promise<void> =>
        authInstance.post('RoleGroupList/deleteRolesInGroup', data).then(x => x.data),
};
